module.exports = __webpack_public_path__ + "media/admin/img_admin_event_search_banner_pc-403add4c.png";